import type { ReactNode } from 'react';
import { GateScreen } from './screens/GateScreen.js';
import { MapScreen } from './screens/MapScreen.js';
import { useStore } from './store/StoreContext.js';

export function App(): ReactNode {
  const { phase } = useStore();
  if (phase === 'loading') {
    return (
      <main className="boot">
        <span className="boot__compass" aria-hidden="true" />
        <p className="boot__text">Chargement du voyage...</p>
      </main>
    );
  }
  if (phase === 'gate') return <GateScreen />;
  return <MapScreen />;
}
